import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { APIResponse } from '../../Shared/shared';

interface PersonAccrualBalanceModels {
  id: string;
  personId: string;
  personName: string;
  personName2: string;
  accrualType: string;
  referenceId: any;
  referenceName: any;
  referenceName2: any;
  referenceType: any;
  value: number;
  increaseFlag: boolean;
  startDate: string;
  endDate: string;
  description: string;
  balanceAfter: number;
  organizationId: string;
}

export const addPerAccrualBalance = createAsyncThunk(
  'PersonAccrualBalance/addPerAccrualBalance',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Persons/AddPerAccrualBalance', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAccrualBalanceByPersonId = createAsyncThunk(
  'PersonAccrualBalance/getAccrualBalanceByPersonId',
  async (personId: string, { rejectWithValue }) => {
    try {
      const params = { PersonId: personId };
      const { data } = await ntxAPI.get<APIResponse<number>>(`Persons/GetAccrualBalanceByPersonIdQuery`, { params });

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPerAccrualBalanceByPersonIdList = createAsyncThunk(
  'PersonAccrualBalance/getPerAccrualBalanceByPersonIdList',
  async (personId: string, { rejectWithValue }) => {
    try {
      const params = { PersonId: personId };
      const { data } = await ntxAPI.get(`Persons/GetPerAccrualBalanceByPersonIdList`, { params });
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  PerAccrualBalanceList: PersonAccrualBalanceModels[];
  loading: boolean;
  error: any | null;
  //
  AccrualBalance: number;
  loading2: boolean;
  error2: any | null;
} = {
  PerAccrualBalanceList: [],
  loading: false,
  error: null,
  //
  AccrualBalance: 0,
  loading2: false,
  error2: null
};

const personAccrualBalanceSlice = createSlice({
  name: 'PersonAccrualBalance',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getPerAccrualBalanceByPersonIdList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getPerAccrualBalanceByPersonIdList.fulfilled,
        (state, action: PayloadAction<PersonAccrualBalanceModels[]>) => {
          state.loading = false;
          state.PerAccrualBalanceList = action.payload;
        }
      )
      .addCase(getPerAccrualBalanceByPersonIdList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      // .addCase(getAccrualBalanceByPersonId.pending, (state, action) => {
      //   state.loading2 = true;
      //   state.error2 = null;
      // })
      // .addCase(getAccrualBalanceByPersonId.fulfilled, (state, action: PayloadAction<number>) => {
      //   state.loading2 = false;
      //   state.AccrualBalance = action.payload;
      // })
      // .addCase(getAccrualBalanceByPersonId.rejected, (state, action: PayloadAction<any>) => {
      //   state.loading2 = false;
      //   state.error2 = action.payload;
      // });
  }
});

export default personAccrualBalanceSlice.reducer;
